<template>
  <div class="document-table-view">
    <table class="document-table-view__table">
      <tbody>
        <tr>
          <th>Title</th>
          <th>Description</th>
          <th>Date</th>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="(document, index) in documentData.displayDocuments"
          :key="index"
          :class="rowClassModifiers(document, index)"
          @click="onOpen(document, index)"
        >
          <td>
            {{ document.displayDocumentTitle }}
          </td>
          <td>
            {{ document.displayDocumentDescription }}
          </td>
          <td>
            {{ parseDate(document) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script src="./document-table-view.js"></script>
<style src="./document-table-view.scss" lang="scss"></style>
